import React from 'react';
import { BookOpen } from 'lucide-react';
import type { ListAnalysesWidgetData } from '../../../types/agentWidgets';

interface Props {
  data: ListAnalysesWidgetData;
}

const STATUS_COLORS: Record<string, string> = {
  UP_TO_DATE: 'bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-400',
  PROCESSING: 'bg-amber-100 text-amber-700 dark:bg-amber-900/30 dark:text-amber-400',
  NEEDS_REGENERATION: 'bg-yellow-100 text-yellow-700 dark:bg-yellow-900/30 dark:text-yellow-400',
  FAILED: 'bg-red-100 text-red-700 dark:bg-red-900/30 dark:text-red-400',
};

export const ListAnalysesWidget: React.FC<Props> = ({ data }) => {
  if (data.analyses.length === 0) return null;

  return (
    <div className="mt-1.5 space-y-1">
      <p className="text-[10px] uppercase tracking-wide text-gray-400 dark:text-gray-500 font-medium">
        {data.analyses.length} analys{data.analyses.length !== 1 ? 'es' : 'is'}
      </p>
      <div className="space-y-1">
        {data.analyses.map((a) => (
          <div
            key={a.id}
            className="flex items-center gap-2 text-[11px] bg-purple-50/70 dark:bg-purple-900/10 rounded px-2 py-1.5"
          >
            <BookOpen className="h-3 w-3 text-purple-500 dark:text-purple-400 flex-shrink-0" />
            <span className="font-medium text-purple-700 dark:text-purple-300 truncate flex-1 min-w-0">
              {a.name}
            </span>
            <span className="text-[10px] text-gray-400 dark:text-gray-500 whitespace-nowrap">
              {a.type.replace(/_/g, ' ').toLowerCase()}
            </span>
            <span
              className={`text-[10px] px-1.5 py-0.5 rounded-full whitespace-nowrap ${
                STATUS_COLORS[a.status] || 'bg-gray-100 text-gray-600 dark:bg-gray-800 dark:text-gray-400'
              }`}
            >
              {a.status.replace(/_/g, ' ').toLowerCase()}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};
